import React from 'react'
import CustomPath from './CustomPath'

const OUTLINE_PATH = 'M32 0L64 56H0L32 0Z'
const RAW_WIDTH = 64
const RAW_HEIGHT = 56

/**
 * Triangle shape component
 * @type {import('./CustomPath').CustomPath}
 */
export const TriangleShape = React.forwardRef((props, ref) => {
    return <CustomPath {...props} ref={ref} data={OUTLINE_PATH} rawWidth={RAW_WIDTH} rawHeight={RAW_HEIGHT} />
})

export default TriangleShape
